import React, { useEffect, useState } from "react";
import "./App.css";
import Races from "./components/race/Races";
import {
  BrowserRouter,
  RouterProvider,
  Routes,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";

import Loading from "./loader/Loading";
import { FavoritesProvider } from "./services/FavoritesProvider";
import LivePage from "./components/LivePage";
import CookieConfirmation from "./components/Tools/CookieConfirmation";
import Display from "./components/display/Display";

const AppInside = () => {
  const [usrType,setUsrType] = useState<boolean>(false)
  const [accToken,setAccToken] = useState<string>("")

  useEffect(() => {
    let usr = localStorage.getItem("user_type");
    setUsrType(usr === null ? false : true);
    
    let acc = localStorage.getItem("accestoken");
    if (acc !== null){
      setAccToken(acc);
    }
    
  },[])
  
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Races />,
    },
    {
      path: "/loading",
      element: <Loading />,
    },
    {
      path: "/live",
      element: <LivePage />,
    },
    {
      path: "/display",
      element: <Display />,
    },
    {
      path: "*",
      element: <Races />,
    },
  ]);
  if (!usrType){
    return <CookieConfirmation onExit={() => setUsrType(true)} />
  }
  return (
    <FavoritesProvider>
      <RouterProvider router={router} />
    </FavoritesProvider>
  );
};

export default AppInside;
